export default {
  // Labels shared by the approval calendar and request details.
  calendar: {
    title: 'ปฏิทินอนุมัติ',
    requestTypes: 'ประเภทคำขอ:',
    year: 'ปี',
    month: 'เดือน',
    filterStatus: 'กรองสถานะ'
  },
  detail: {
    title: 'รายละเอียดคำขอเวลา',
    requester: 'ชื่อ - นามสกุล',
    requestType: 'ประเภทคำขอ',
    date: 'วันที่',
    period: 'ช่วงเวลา',
    status: 'สถานะ',
    approver: 'ผู้อนุมัติ',
    reason: 'เหตุผล',
    allowance: 'เบี้ยเลี้ยงพิเศษ',
    value: 'จำนวน',
    adjustTime: 'ปรับเวลา OT ที่อนุมัติ',
    actionFailed: 'บันทึกผลไม่สำเร็จ กรุณาลองใหม่'
  },
  exportUi: {
    title: 'ส่งออกข้อมูล',
    description:
      'เลือกพนักงาน ประเภทรายงาน และช่วงวันที่ที่ต้องการส่งออกข้อมูล',
    company: 'บริษัท {{company}}',
    create: 'สร้างไฟล์ส่งออก',
    chooseData: 'เลือกข้อมูล',
    periodLanguage: 'ช่วงวันที่และภาษา',
    language: 'ภาษาในไฟล์',
    hint: 'ไฟล์ที่ส่งออกจะแสดงในประวัติด้านล่าง',
    export: 'ส่งออก',
    history: 'ประวัติการส่งออก',
    fileCount: '{{count}} ไฟล์',
    download: 'ดาวน์โหลด'
  },
  form: {
    start: {
      placeholder: 'เริ่มต้น',
      label: 'เริ่มต้น'
    },
    end: {
      placeholder: 'สิ้นสุด',
      label: 'สิ้นสุด'
    },
    status: {
      placeholder: 'สถานะ',
      label: 'สถานะ'
    },
    reqStart: {
      placeholder: 'โปรดระบุเวลาที่ต้องการ',
      label: 'เวลาเข้า'
    },
    reqEnd: {
      placeholder: 'โปรดระบุเวลาที่ต้องการ',
      label: 'เวลาออก'
    },
    timeIn: {
      placeholder: 'โปรดระบุเวลาที่ต้องการ',
      label: 'เวลาเข้า'
    },
    timeOut: {
      placeholder: 'โปรดระบุเวลาที่ต้องการ',
      label: 'เวลาออก'
    },
    date: {
      placeholder: 'โปรดเลือกวันที่ต้องการ',
      label: 'วันที่'
    },
    allowanceUseDate: {
      placeholder: 'โปรดเลือกวันที่ร้องขอเงินได้พิเศษ',
      label: 'วันที่'
    },
    value: {
      placeholder: 'โปรดกรอกจำนวนเงินได้พิเศษ',
      label: 'ค่าเงินได้พิเศษ'
    },
    reason: {
      placeholder: 'โปรดกรอกเหตุผล',
      label: 'เหตุผล'
    },
    allowanceCode: {
      placeholder: 'โปรดเลือกประเภทเงินได้พิเศษ',
      label: 'ประเภทเงินได้พิเศษ'
    },
    employee_code: {
      placeholder: 'โปรดเลือกผู้ที่ต้องการให้รับการอนุมัติแทนตน',
      label: 'ผู้อนุมัติแทนตน'
    },
    employee: {
      placeholder: 'โปรดเลือกพนักงานที่ต้องการ',
      label: 'พนักงาน'
    },
    EExportType: {
      placeholder: 'โปรดเลือกประเภทเอกสารที่ต้องการ',
      label: 'ประเภทเอกสาร'
    }
  },
  table: {
    status: 'สถานะ',
    action: 'ดำเนินการ',
    date: 'วันที่',
    title: 'ประเภทคำขอ',
    remark: 'หมายเหตุ',
    requester: 'ผู้ขอ',
    createdAt: 'วันที่สร้าง',
    fileName: 'ชื่อไฟล์',
    fileUuid: 'รหัสไฟล์',
    url: 'ดาวน์โหลด'
  },
  modal: {
    approve: 'คุณต้องการอนุมัติรายการลาที่เลือกหรือไม่?',
    reject: 'คุณต้องการปฏิเสธรายการลาที่เลือกหรือไม่?',
    approver: 'ผู้อนุมัติ'
  },
  buttons: {
    refresh: 'แสดงผลข้อมูลใหม่',
    export: 'ส่งออกข้อมูล'
  },
  exportJob: {
    queued: {
      title: 'ส่งคำขอ Export เข้าคิวแล้ว',
      description: 'ระบบกำลังรอประมวลผลคำขอของคุณ'
    },
    processing: {
      title: 'กำลังเตรียมไฟล์ Export',
      description: 'รายการไฟล์จะอัปเดตอัตโนมัติเมื่อไฟล์พร้อม'
    },
    longRunning: {
      title: 'การ Export ใช้เวลานานกว่าปกติ',
      description: 'คุณสามารถออกจากหน้านี้และกลับมาในแท็บเดิมได้'
    },
    failed: {
      title: 'Export ไม่สำเร็จ',
      description: 'ระบบไม่สามารถสร้างไฟล์ได้ กรุณาลองใหม่อีกครั้ง'
    },
    'tracking-error': {
      title: 'ไม่สามารถตรวจสอบสถานะ Export ได้',
      description: 'กรุณากดแสดงผลข้อมูลใหม่เพื่อตรวจสอบไฟล์'
    },
    success: 'ไฟล์ Export พร้อมดาวน์โหลดแล้ว',
    submitFailed: 'ไม่สามารถเริ่ม Export ได้ กรุณาลองใหม่อีกครั้ง'
  },
  radio: {
    en: 'EN',
    th: 'TH'
  },
  status: {
    'Wait work time': 'รอเวลาเข้า-ออก',
    'Pending approve': 'รออนุมัติ',
    'Pending cancel': 'รอยกเลิก',
    'Partial approve': 'อนุมัติบางส่วน',
    'Partial preview': 'พรีวิวบางส่วน',
    'Partial cancel': 'ยกเลิกบางส่วน',
    Approve: 'อนุมัติ',
    Canceled: 'ยกเลิก',
    Reject: 'ปฏิเสธ'
  },
  title: {
    OT: 'โอที',
    'Special Allowance': 'เงินได้พิเศษ',
    'Edit Time': 'เพิ่ม/แก้ไขเวลา'
  }
}
